import { multiSelectFilter, createActionsColumn, urlCell } from '../columnUtils';

export const createNtaComorbiditiesI8000Columns = (setSelectedItem, setDrawerVisible, handleDelete) => [
  {
    id: 'comorbidityCode',
    header: 'Comorbidity Code',
    accessorKey: 'comorbidityCode',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'displayName',
    header: 'Display Name',
    accessorKey: 'displayName',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'points',
    header: 'Points',
    accessorKey: 'points',
    enableSorting: true,
    sortingFn: 'alphanumeric',
    filterFn: multiSelectFilter
  },
  {
    id: 'sourceType',
    header: 'Source Type',
    accessorKey: 'sourceType',
    enableSorting: true,
    sortingFn: 'text',
    filterFn: multiSelectFilter
  },
  {
    id: 'sourceUrl',
    header: 'Source URL',
    accessorKey: 'sourceUrl',
    enableSorting: false,
    enableColumnFilter: false,
    cell: urlCell
  },
  createActionsColumn(setSelectedItem, setDrawerVisible, handleDelete)
];
